import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getUsersName } from '../../util/api';
import { states as inquiryStates } from '../../transactions/transactionProcessInquiry';
import { fetchUnreadMessagesLog } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_ORDERS_OR_SALES_REQUEST = 'app/InboxPage/FETCH_ORDERS_OR_SALES_REQUEST';
export const FETCH_ORDERS_OR_SALES_SUCCESS = 'app/InboxPage/FETCH_ORDERS_OR_SALES_SUCCESS';
export const FETCH_ORDERS_OR_SALES_ERROR = 'app/InboxPage/FETCH_ORDERS_OR_SALES_ERROR';

export const SET_PROVIDER_NAMES = 'app/InboxPage/SET_PROVIDER_NAMES';

// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchOrdersOrSalesError: null,
  pagination: null,
  transactionRefs: [],
  providerNames: [],
};

export default function inboxPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ORDERS_OR_SALES_REQUEST:
      return { ...state, fetchInProgress: true, fetchOrdersOrSalesError: null };

    case FETCH_ORDERS_OR_SALES_SUCCESS: {
      const { currentUser } = payload;  // Extract tab from the payload
      // const transactions = sortedTransactions(payload.data.data, currentUser);
      const transactions = payload.data.data;
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ORDERS_OR_SALES_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchOrdersOrSalesError: payload };

    case SET_PROVIDER_NAMES:
      return {
        ...state,
        providerNames: Array.isArray(payload) ? payload : Object.values(payload),
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchOrdersOrSalesRequest = () => ({ type: FETCH_ORDERS_OR_SALES_REQUEST });
const fetchOrdersOrSalesSuccess = (response, currentUser) => ({
  type: FETCH_ORDERS_OR_SALES_SUCCESS,
  payload: {
    data: response.data,
    currentUser,
  },
});
const fetchOrdersOrSalesError = e => ({
  type: FETCH_ORDERS_OR_SALES_ERROR,
  error: true,
  payload: e,
});

const setProviderNames = names => ({
  type: SET_PROVIDER_NAMES,
  payload: names,
});

// ================ Thunks ================ //

const INBOX_PAGE_SIZE = 10;


export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  // const { tab } = params;

  // const onlyFilterValues = {
  //   orders: 'order',
  //   sales: 'sale',
  // };

  // const onlyFilter = onlyFilterValues[tab];
  // if (!onlyFilter) {
  //   return Promise.reject(new Error(`Invalid tab for InboxPage: ${tab}`));
  // }

  const currentUser = getState().user.currentUser;

  const { page = 1, tab } = parse(search);

  let onlyFilter = '';
  let states = '';

  // if (!tab) {
  //   onlyFilter = 'sale';
  // }

  const nonIntroducedStates = Object.values(inquiryStates).filter(i => i !== "introduced");
  const nonIntroducedStatesString = nonIntroducedStates.map(i => `state/${i}`).join(",");

  if (tab === 'listings') {
    onlyFilter = 'sale';
    states = nonIntroducedStatesString;
  } else if (tab === 'responses') {
    onlyFilter = 'order';
    states = nonIntroducedStatesString;
  } else if (tab === 'introduced') {
    states = 'state/introduced';
  }

  dispatch(fetchOrdersOrSalesRequest());

  const apiQueryParams = {
    // only: onlyFilter,
    ...(onlyFilter && { only: onlyFilter }),
    ...(states && { states }),
    // lastTransitions: getAllTransitionsForEveryProcess(),
    include: [
      'listing',
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
      // 'messages',
      'messages.sender',
    ],
    'fields.transaction': [
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
      'lineItems',
      'protectedData',
      'metadata',
    ],
    'fields.listing': ['title', 'availabilityPlan', 'publicData'],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
    page,
    perPage: INBOX_PAGE_SIZE,
    // sort: 'meta_lastActionTime,lastMessageAt',
    sort: 'meta_lastActionTime,lastMessageAt',
  };

  try {
    const response = await sdk.transactions.query(apiQueryParams);

    dispatch(addMarketplaceEntities(response));
    dispatch(fetchOrdersOrSalesSuccess(response, currentUser));

    // Counterparty names are only rendered for introduced transactions. The 'listings' and
    // 'responses' tabs exclude that state, so don't fetch names there at all.
    const tabCanShowNames = tab !== 'listings' && tab !== 'responses';

    if (tabCanShowNames) {
      const providerRes = await getUsersName({});

      if (providerRes.success) {
        dispatch(setProviderNames(providerRes.providers));
      }
    } else {
      // Drop names left in the store by a previously visited tab.
      dispatch(setProviderNames([]));
    }

    dispatch(fetchUnreadMessagesLog());

    return response;

  } catch (e) {
    dispatch(fetchOrdersOrSalesError(storableError(e)));
    throw e;
  }
};